import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core, Decorative } from "@faire/design-tokens";
import { FooterSEOContent } from "@faire/retailer-visitor-shared/components/Footer/FooterSEOContent";
import { TestimonialsCardSection } from "@faire/retailer-visitor-shared/components/TestimonialsCardSection/TestimonialsCardSection";
import { BelongingEmployeeCommunities } from "@faire/retailer-visitor-shared/views/careers/__internal__/BelongingAtFaire/BelongingEmployeeCommunities";
import { BelongingEmployeesCustomersSection } from "@faire/retailer-visitor-shared/views/careers/__internal__/BelongingAtFaire/BelongingEmployeesCustomersSection";
import { BelongingHeroSection } from "@faire/retailer-visitor-shared/views/careers/__internal__/BelongingAtFaire/BelongingHeroSection";
import { BelongingLifeAtFaire } from "@faire/retailer-visitor-shared/views/careers/__internal__/BelongingAtFaire/BelongingLifeAtFaire";
import { BelongingPageLargeImage } from "@faire/retailer-visitor-shared/views/careers/__internal__/BelongingAtFaire/BelongingPageLargeImage";
import { BelongingWordsInAction } from "@faire/retailer-visitor-shared/views/careers/__internal__/BelongingAtFaire/BelongingWordsInAction";
import { FAIRE_BELONGING_EMPLOYEES } from "@faire/retailer-visitor-shared/views/careers/__internal__/BelongingAtFaire/faireBelongingEmployees";
import { BelongingAtFaireFooterImage } from "@faire/retailer-visitor-shared/views/careers/__internal__/components/FullWidthImages";
import { JobOpeningsSection } from "@faire/retailer-visitor-shared/views/careers/__internal__/components/JobOpeningsSection";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { Column } from "@faire/web--source/slate/Layout";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { trackCareersPageBelongingatfaireView } from "@faire/web-api--source/events/careersPage/view/belongingatfaire";
import React, { useEffect } from "react";
export var BelongingAtFairePage = function() {
    useEffect(function() {
        trackCareersPageBelongingatfaireView();
    }, []);
    var strictLocalize = useStrictLocalization().strictLocalize;
    var BelongingPageLargeImageComponent = BelongingPageLargeImage(strictLocalize);
    return /*#__PURE__*/ _jsxs(Column, {
        children: [
            /*#__PURE__*/ _jsx(BelongingHeroSection, {}),
            /*#__PURE__*/ _jsx(BelongingEmployeesCustomersSection, {}),
            /*#__PURE__*/ _jsx(BelongingPageLargeImageComponent, {}),
            /*#__PURE__*/ _jsx(BelongingWordsInAction, {}),
            /*#__PURE__*/ _jsx(BelongingLifeAtFaire, {}),
            /*#__PURE__*/ _jsx(TestimonialsCardSection, {
                testimonials: FAIRE_BELONGING_EMPLOYEES(strictLocalize),
                title: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "6mWdAq",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Employee Voices"
                        }
                    ]
                }),
                titleColor: Core.text.subdued,
                backgroundColor: Decorative.tint.neutral,
                textColor: Core.text.default,
                textStyle: {
                    mobileAndAbove: "subheadingSansRegular",
                    tabletAndAbove: "paragraphSansMedium",
                    desktopAndAbove: "subheadingSansMedium",
                    xLargeAndAbove: "sectionHeaderSansMedium"
                }
            }),
            /*#__PURE__*/ _jsx(BelongingEmployeeCommunities, {}),
            /*#__PURE__*/ _jsx(JobOpeningsSection, {}),
            /*#__PURE__*/ _jsx(BelongingAtFaireFooterImage, {}),
            /*#__PURE__*/ _jsx(FooterSEOContent, {})
        ]
    });
};
